@if (housekeepingReport?.interimCleaningSummaries?.length) {
  <p-table
    [value]="housekeepingReport.interimCleaningSummaries"
    [style]="{'font-size': '12px'}"
    styleClass="p-datatable-sm">
    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th>#</th>
        <th>Status</th>
        <th>Dept</th>
        <th>Type</th>
        <th>Prop</th>
        <th>Start</th>
        <th>Time</th>
        <th>Assigned</th>
        <th>Notes</th>
      </tr>
    </ng-template>
    <!-- Body -->
    <ng-template pTemplate="body" let-workOrder let-i="rowIndex">
      <tr>
        <td>{{ i + 1 }}</td>
        <td>
          <a target="_blank" [href]="'https://admin.kbmhawaii.com/order/' + workOrder?.orderId">Open</a>
        </td>
        <td>H/K</td>
        <td>Interim</td>
        <td>{{ workOrder?.propertyCode }}</td>
        <td>{{ workOrder?.scheduledServiceDate | date:'E MM-dd-yyyy' }}</td>
        <td>{{ workOrder?.scheduledServiceDateTimeStart | date:'h:mm a' }}</td>
        <td>{{ workOrder?.assignee }}</td>
        <td>
          @if (workOrder?.privateNotes) {
            <div>
              <b>NOTES FROM OPS:</b> {{ workOrder.privateNotes }}<br>
            </div>
          }
          @if (workOrder?.technicianNotes) {
            <div>
              <b>NOTES TO HOUSEKEEPER:</b> {{ workOrder.technicianNotes }}<br>
            </div>
          }
          @if (workOrder?.guestNotes) {
            <div>
              <b>NOTES FROM GUEST:</b> {{ workOrder.guestNotes }}<br>
            </div>
          }
          @if (workOrder?.description) {
            <div>
              <b>DESCRIPTION:</b> {{ workOrder.description }}<br>
            </div>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
}
